var _path, _path2, _circle, _path3, _path4, _path5, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYourLinks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9165 14L25.6463 12.2702C25.8415 12.0749 26.1581 12.0749 26.3534 12.2702L28.0832 14",
    stroke: "#0e0333",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9165 15.6667L25.6463 13.9369C25.8415 13.7417 26.1581 13.7417 26.3534 13.9369L28.0832 15.6667",
    stroke: "#0e0333",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 14,
    r: 4.5,
    stroke: "#0e0333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18.5H23.75C22.2312 18.5 21 19.7312 21 21.25V21.25C21 22.7688 22.2312 24 23.75 24H27.25C29.0449 24 30.5 25.4551 30.5 27.25V27.25C30.5 29.0449 29.0449 30.5 27.25 30.5H14",
    stroke: "#0e0333",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9165 26L13.6463 24.2702C13.8415 24.0749 14.1581 24.0749 14.3534 24.2702L16.0832 26",
    stroke: "#0e0333",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9165 27.6667L13.6463 25.9369C13.8415 25.7417 14.1581 25.7417 14.3534 25.9369L16.0832 27.6667",
    stroke: "#0e0333",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 26,
    r: 4.5,
    stroke: "#0e0333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourLinks);
export default __webpack_public_path__ + "static/media/your-links.b8cda7ee757686819297171e0008bb9a.svg";
export { ForwardRef as ReactComponent };